import { extend } from "@react-three/fiber";
import { shaderMaterial } from "@react-three/drei";
import * as THREE from "three";

export const TransitionMaterial = shaderMaterial(
  {
    progression: 1,
    tex: null as unknown as THREE.Texture,
    tex2: null as unknown as THREE.Texture,
    transition: 0,
    alpha: 1,
  },
  /* glsl */ `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  /* glsl */ `
    varying vec2 vUv;
    uniform sampler2D tex;
    uniform sampler2D tex2;
    uniform float progression;
    uniform float transition;
    uniform float alpha;
    void main() {
      vec2 uv = vUv;
      vec4 _texture = texture2D(tex, uv);
      vec4 _texture2 = texture2D(tex2, uv);

      // transition mode:
      //   0 = pixel-wise mix (cross-fade, used by ScrollTransitionScene)
      //   1 = vertical wipe (used for page transition — no semi-transparent
      //       overlap of two scenes; each pixel shows exactly one source)
      vec4 result;
      if (transition < 0.5) {
        float p = smoothstep(0.0, 1.0, progression);
        result = mix(_texture, _texture2, p);
      } else {
        // Wipe sweeping the snapshot off the screen, revealing the new page.
        // We stretch progression to (-edge .. 1+edge) so both endpoints are
        // fully one source — no residual semi-transparent strip at p=0 or 1.
        // Narrow edge (0.02) so there's effectively no double-exposure band.
        float edge = 0.02;
        float p = mix(-edge, 1.0 + edge, smoothstep(0.0, 1.0, progression));
        float wipe = smoothstep(p - edge, p + edge, uv.y);
        result = mix(_texture2, _texture, wipe);
      }
      gl_FragColor = vec4(result.rgb, result.a * alpha);
    }
  `
);

extend({ TransitionMaterial });
